import { CreateActionTask } from "../../types";

export const defaultValues = (data?: CreateActionTask) => {
  return {
    mr_action_task_code: data?.mr_action_task_code ?? "",
    mr_action_task_name: data?.mr_action_task_name ?? "",
    description: data?.description ?? ""
  };
};